module.exports = __webpack_public_path__ + "static/media/img2-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_suelo/ZN/img2-1.png
// module id = 1347
// module chunks = 3